import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { monthKeyInUlaanbaatar } from "../utils/ulaanbaatarTime";
import {
  emptyAccountingExcelRow,
  toAccountingExcelRow,
} from "./toAccountingPayload";

const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

function monthKey(row) {
  return monthKeyInUlaanbaatar(row.trnDate);
}

function sheetTotals(rows) {
  let income = 0;
  let expense = 0;
  rows.forEach((r) => {
    const a = num(r.amount);
    if (a > 0) income += a;
    else if (a < 0) expense += Math.abs(a);
  });
  return { income, expense, count: rows.length };
}

/**
 * Сараар sheet + Тойм sheet.
 * Detail columns = canonical English keys (same as JSON).
 */
export function buildBankTransactionLogWorkbook(payload) {
  const {
    accountNumber,
    startDate,
    endDate,
    exportedAt,
    timezone,
    rows = [],
  } = payload;

  const byMonth = new Map();
  rows.forEach((row) => {
    const key = monthKey(row);
    if (!byMonth.has(key)) byMonth.set(key, []);
    byMonth.get(key).push(row);
  });

  const monthKeys = [...byMonth.keys()].sort();
  const workbook = XLSX.utils.book_new();

  const summaryRows = [
    { Талбар: "Данс", Утга: accountNumber },
    { Талбар: "Эхлэх огноо", Утга: startDate },
    { Талбар: "Дуусах огноо", Утга: endDate },
    {
      Талбар: "Цагийн бүс",
      Утга: timezone || "Asia/Ulaanbaatar (UTC+8)",
    },
    { Талбар: "Экспорт хийсэн", Утга: exportedAt || dayjs().format("YYYY-MM-DD HH:mm:ss") },
    { Талбар: "Нийт мөр", Утга: rows.length },
    { Талбар: "", Утга: "" },
    { Талбар: "Сар", Утга: "Мөр / Орлого / Зарлага" },
  ];

  let totalIncome = 0;
  let totalExpense = 0;
  monthKeys.forEach((mk) => {
    const t = sheetTotals(byMonth.get(mk));
    totalIncome += t.income;
    totalExpense += t.expense;
    summaryRows.push({
      Талбар: mk,
      Утга: `${t.count} мөр | Орлого: ${t.income.toFixed(2)} | Зарлага: ${t.expense.toFixed(2)}`,
    });
  });
  summaryRows.push({ Талбар: "", Утга: "" });
  summaryRows.push({
    Талбар: "НИЙТ ОРЛОГО",
    Утга: Number(totalIncome.toFixed(2)),
  });
  summaryRows.push({
    Талбар: "НИЙТ ЗАРЛАГА",
    Утга: Number(totalExpense.toFixed(2)),
  });
  summaryRows.push({
    Талбар: "ЦЭВЭР (+орлого -зарлага)",
    Утга: Number((totalIncome - totalExpense).toFixed(2)),
  });

  XLSX.utils.book_append_sheet(
    workbook,
    XLSX.utils.json_to_sheet(summaryRows),
    "Тойм"
  );

  monthKeys.forEach((mk) => {
    const monthRows = byMonth.get(mk);
    const excelRows = monthRows.map((r) => toAccountingExcelRow(r));
    const t = sheetTotals(monthRows);
    excelRows.push({
      ...emptyAccountingExcelRow(),
      description: "НИЙТ",
      income: Number(t.income.toFixed(2)),
      expense: Number(t.expense.toFixed(2)),
    });

    const sheetName = mk.slice(0, 31);
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(excelRows),
      sheetName
    );
  });

  return workbook;
}

export function downloadBankTransactionLogExcel(payload) {
  const workbook = buildBankTransactionLogWorkbook(payload);
  const fileName = `BTL_${payload.accountNumber}_${payload.startDate}_${payload.endDate}.xlsx`;
  XLSX.writeFile(workbook, fileName);
}

export { toAccountingExcelRow, toAccountingPayload } from "./toAccountingPayload";
